import * as BusinessFunction from "../constants/BusinessFunction";
import {changeLocale_} from "../login/Security";
import {logout} from "../login/Security";

export class NamaPresenter {
    /**
     *
     * @param {EditPlace|EntityListPlace} place
     */
    constructor(place) {
        this.place = place;
    }

    canNavigate() {
        return {canNavigate: true, msg: ""};
    }

    start() {
        let view = $(`<div>Now Inside ${this.place.tokenize()}`);
        view.appendTo("#example.page-content-wrapper");
    }

    businessFunctions() {
        let that = this;
        if (that.idsWithActions)
            return that.idsWithActions;
        that.idsWithActions = {};
        that.idsWithActions[BusinessFunction.LogOut] = () => logout();
        that.idsWithActions[BusinessFunction.changeLocale] = () => changeLocale_();
        return that.idsWithActions;
    }

    hasGUIAction(businessId) {
        return false;
    }

    beforeClosing() {

    }
}